import { Curso } from "./style";
import {BsFillCheckCircleFill} from "react-icons/bs"

function CursoComponent() {
  return (
    <Curso id="curso">
      <div id="pather-div">
        <section id="sec1">
          <span id="solution">a solução ideal!</span>
          <h1>Agora veja sobre o English Standard Experience, meu curso!</h1>
          <p id="desc">
            160 horas de Programa Customizado voltado para resultado + Bônus!{" "}
            <br />
            <br />
            <span id="see">Veja como funciona:</span>
          </p>
          <div id="ul">
            <p><BsFillCheckCircleFill />Consultoria de Idioma Inicial;</p>
            <p><BsFillCheckCircleFill />Aplicação do Processo Comportamental&#169;;</p>
            <p><BsFillCheckCircleFill />4 Encontros Mensais (ao vivo);</p>
            <p><BsFillCheckCircleFill />Acompanhamento semanal do planejamento;</p>
            <p><BsFillCheckCircleFill />Inserção regular de conteúdo, recursos e atividades;</p>
            <p><BsFillCheckCircleFill />Contato diário com o idioma através interações e atividades.</p>
          </div>
        </section>
        <section id="sec2">
            <p>Agora veja alguns bônus que serão disponibilizados:</p>
            <ol>
                <li>Nivelamento inicial (teste, entrevista e mapeamento comportamental);</li>
                <li>Técnicas de uso eficaz das 4 habilidades (fala, escrita, audição e leitura);</li>
                <li>Técnicas eficazes para quebra de bloqueios e traumas com o idioma;</li>
                <li>Mentoria completa de aplicação de técnicas e atividades extras;</li>
                <li>Sugestão de práticas e atividades para a área de atuação do cliente;</li>
                <li>Certificado de proficiência;</li>
            </ol>
        </section>
      </div>
    </Curso>
  );
}

export default CursoComponent;
